import React from 'react';
import StockNews from '../StockDetails/StockNews/StockNews';

const PortfolioNews = ({stocks}) => {
    const newsQuery = stocks?.map((stock) => stock.longname).join(" OR ")
    
    return (
        <div className="w-100 mt-4">
            <StockNews stock={newsQuery} />
        </div>
    )
}

export default PortfolioNews
